/**
 * External dependencies
 */
import { createSelector } from 'reselect';
import { get, find, map, sortBy, reverse } from 'lodash';

/**
 * Internal dependencies
 */
import { getAllCoupons } from 'state/coupons/selectors';
import { getAllAddons } from 'state/addons/selectors';

export const getCurrentUniversalImporterId = (state) => get(state, ['currentUniversalImporter', 'items']);

export const getCurrentUniversalImporter = (state) => {
    return get(state, ['currentUniversalImporter', 'items'], []);
};

export const requestingCurrentUniversalImporter = (state) => get(state, ['currentUniversalImporter', 'requesting'], false);

export const errorRequestingCurrentUniversalImporter = (state) => get(state, ['currentUniversalImporter', 'error'], false);

export const hasScheduledChanges = createSelector(
    getCurrentUniversalImporter,
    (currentUniversalImporter) => {
        return get(currentUniversalImporter, ['has_scheduled_changes'], false);
    },
);
export const getCurrentUniversalImporterPlanId = createSelector(
    getCurrentUniversalImporter,
    (currentUniversalImporter) => {
        return get(currentUniversalImporter, ['plan_id'], null);
    },
);